import { Icon, IIconProps } from 'native-base';
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

export const SunsetIcon = ({ size = 'sm', ...props }: IIconProps) => {
  return (
    <Icon size={size} viewBox="0 0 6 6" fill="none" {...props}>
      <G clip-path="url(#clip0_26234_3752)">
        <Path
          d="M1 4.5H0.5M1.57853 3.07853L1.22498 2.72498M4.42145 3.07853L4.775 2.72498M5.5 4.5H5M1.75 4.5C1.75 3.80964 2.30964 3.25 3 3.25C3.69036 3.25 4.25 3.80964 4.25 4.5M5.5 5.5H0.5M4 1.25L3 2.25M3 2.25L2 1.25M3 2.25V0.5"
          stroke="#4E5BA6"
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_26234_3752">
          <Rect width="6" height="6" fill="white" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};
